import { cva, VariantProps } from "class-variance-authority";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "~/components/atoms/Avatar";
import { cn } from "~/lib/utils";
import Image from "~/components/atoms/Image";
import profileAvatar from "~/assets/profile-avatar.svg";

const variants = cva("", {
    variants: {
        size: {
            athleteProfile: ["size-[75px] sm:size-[130px]"],
            header: ["size-[42px]"],
        },
    },
    defaultVariants: {
        size: "athleteProfile",
    },
});

export interface AthleteAttributes extends VariantProps<typeof variants> {
    avatarUrl?: string;
    className?: string;
    title?: string;
}

const AthleteAvatar = React.forwardRef<
    React.ComponentRef<typeof AvatarPrimitive.Root>,
    AthleteAttributes
>(({ title, avatarUrl, className, size }, ref) => {
    const avatarTitle = title ? `${title} Avatar` : "Avatar";
    const baseClasses =
        "rounded-full border border-gray-20 bg-white flex items-center justify-center";
    const classNames = cn(variants({ size }), baseClasses, className);

    return (
        <Avatar ref={ref} className={classNames}>
            <AvatarImage src={avatarUrl} alt={avatarTitle} />
            <AvatarFallback>
                <Image src={profileAvatar} className="size-full" alt={avatarTitle} />
            </AvatarFallback>
        </Avatar>
    );
});
AthleteAvatar.displayName = "AthleteAvatar";

export default AthleteAvatar;
